"use client";
import { Container } from "components/layout/Container";
import { Button } from "components/UI/buttons/Button";
import { Heading } from "components/UI/typography/Heading";
import s from "./SectionShortDescription.module.scss";
import { animateScroll } from "@/utils/animateScroll";
import { ReactNode } from "react";

type SectionShortDescriptionProps = {
  heading: ReactNode;
  description: string;
  btnText?: string;
};

export const SectionShortDescription = ({ heading, description, btnText }: SectionShortDescriptionProps) => (
  <section className={s.section}>
    <Container className={s.container}>
      <div className={s.left}>
        <Heading level={2} className={s.heading}>
          {heading}
        </Heading>
        {btnText && (
          <Button
            tag="button"
            type="secondary"
            className={s.btn}
            onClick={() => animateScroll(document.body)}
          >
            {btnText}
          </Button>
        )}
      </div>
      <div className={s.right} dangerouslySetInnerHTML={{ __html: description }} />
    </Container>
  </section>
);
